import React, { useState } from "react";
import { ChartBar, ListChecks, SealCheck, ShareNetwork, Stack } from "@phosphor-icons/react";
import { SharedSectionsDialog } from "./SharedSectionsDialog";
import { FormRulesDialog } from "./FormRulesDialog";
import { LeadShareDialog } from "./LeadShareDialog";
import { DesignsManager } from "@/components/thankyou/DesignsManager";
import { ThankYouStats } from "@/components/thankyou/ThankYouStats";
import { BTN_BLACK } from "./AdminModal";

const CARDS = [
  ["shared", "Shared sections", "Trust badges, case results, steps, FAQ, closing call-to-action, the no-fee promise and helpful articles — shared by every landing and thank-you page.", Stack],
  ["designs", "Thank-you designs", "Pick the default thank-you page, preview the ready-made designs or build your own.", SealCheck],
  ["rules", "Form questions", "Choose which questions visitors must answer — for all forms or one form style. Fine-tune a funnel or buyer from its own button.", ListChecks],
  ["share", "Lead fields sent to buyers", "Choose which details each buyer gets by every method — posts, CRMs, files and emails. Give one buyer its own list from their row.", ShareNetwork],
  ["stats", "Thank-you click stats", "See which thank-you design gets the most call, text and article taps — for all buyers or one buyer.", ChartBar],
];

export function PageSettingsPanel() {
  const [open, setOpen] = useState(null);
  const close = () => setOpen(null);
  return (
    <div className="grid gap-3 p-4 md:grid-cols-2" data-testid="page-settings-panel">
      {CARDS.map(([k, title, desc, Icon]) => (
        <div key={k} className="flex flex-col gap-2 border-2 border-black bg-white p-4" data-testid={`page-settings-card-${k}`}>
          <div className="flex items-center gap-2">
            <Icon size={18} weight="bold" />
            <span className="font-chivo font-black">{title}</span>
          </div>
          <p className="text-[12px] leading-snug text-zinc-600">{desc}</p>
          <button type="button" className={`${BTN_BLACK} mt-auto self-start`} onClick={() => setOpen(k)} data-testid={`page-settings-open-${k}`}>
            {k === "stats" ? "View" : "Edit"}
          </button>
        </div>
      ))}
      {open === "shared" && <SharedSectionsDialog onClose={close} />}
      {open === "designs" && <DesignsManager onClose={close} />}
      {open === "rules" && <FormRulesDialog onClose={close} />}
      {open === "share" && <LeadShareDialog onClose={close} />}
      {open === "stats" && <ThankYouStats onClose={close} />}
    </div>
  );
}
